/* Wishlist Engine — migration + sync layer (Sep 10 2026)
   Contract: docs/plans/2026-09-10-wishlist-engine.md
   Loaded on every page by snippets/wishlist-sync.liquid, which has already installed the
   localStorage choke point and queued the shopper's existing saved list as pending adds.

   THE FIRST RULE: never lose a shopper's saved items.
     - the local list stays the working list; the server is a durable copy, not a replacement
     - a pending op is only dropped once the server has confirmed it
     - the local list is a UNION with what the server holds; it is only trimmed for an id the
       server previously confirmed and has now dropped (removed on the shopper's other device)
     - everything here is idempotent: running it twice adds nothing and loses nothing
     - if the API is unreachable, missing or slow, this file does nothing at all and the theme
       behaves exactly as it did before the Wishlist Engine existed. */
(function () {
  'use strict';
  var Q = window.WowWishlist;
  if (!Q || Q.__net) return; Q.__net = 1;

  var CFG = window.WOW_WISHLIST_CFG || {};
  var API = String(CFG.api_base || 'https://ai-api.wowstore.live/api/wishlist').replace(/\/$/, '');
  var CUSTOMER = (CFG.customer && CFG.customer.id) ? CFG.customer : null;
  var EP = {
    mine: API + '/mine', add: API + '/add', remove: API + '/remove', claim: API + '/claim',
    note: API + '/note', status: API + '/status', sourcing: API + '/sourcing', sourcingMine: API + '/sourcing/mine'
  };

  function uniq(a) { var s = {}, o = []; for (var i = 0; i < a.length; i++) { var v = a[i] == null ? '' : String(a[i]); if (v && !s[v]) { s[v] = 1; o.push(v); } } return o; }
  function sessionIds() {
    var out = [], keys = ['lucy_browser_id', 'wowstore_browser_id', 'wow_bid'];
    keys.forEach(function (k) { try { var v = localStorage.getItem(k); if (v) out.push(v); } catch (e) {} });
    if (!out.length) { var id = 'b' + Date.now() + Math.random().toString(36).slice(2, 8); try { localStorage.setItem('lucy_browser_id', id); } catch (e) {} out.push(id); }
    return uniq(out);
  }
  function sessionId() { return sessionIds()[0]; }
  function custBody(b) { b = b || {}; if (CUSTOMER) { b.customer_id = CUSTOMER.id; if (CUSTOMER.sig) b.customer_sig = CUSTOMER.sig; } b.session_id = sessionId(); b.session_ids = sessionIds(); return b; }
  function custQ() {
    var q = 'session_id=' + encodeURIComponent(sessionId());
    sessionIds().forEach(function (s) { q += '&session_ids=' + encodeURIComponent(s); });
    if (CUSTOMER) { q += '&customer_id=' + encodeURIComponent(CUSTOMER.id); if (CUSTOMER.sig) q += '&customer_sig=' + encodeURIComponent(CUSTOMER.sig); }
    return q;
  }
  function req(url, opts) {
    opts = opts || {};
    var ctl = null, to = null;
    try { ctl = new AbortController(); to = setTimeout(function () { try { ctl.abort(); } catch (e) {} }, opts.timeout || 12000); } catch (e) {}
    return fetch(url, {
      method: opts.method || 'GET',
      headers: opts.body ? { 'Content-Type': 'application/json' } : {},
      body: opts.body ? JSON.stringify(opts.body) : undefined,
      credentials: 'omit',
      signal: ctl ? ctl.signal : undefined
    }).then(function (r) {
      if (to) clearTimeout(to);
      return r.text().then(function (t) { var j = null; try { j = t ? JSON.parse(t) : null; } catch (e) {} return { ok: r.ok, status: r.status, data: j }; });
    }).catch(function () { if (to) clearTimeout(to); return { ok: false, status: 0, data: null }; });
  }
  Q.req = req; Q.custBody = custBody; Q.custQ = custQ; Q.sessionIds = sessionIds; Q.customer = CUSTOMER; Q.EP = EP;

  /* ---------- tolerant read of whatever /mine answers ----------
     Rows are keyed server-side by variant_key: "p:<product_id>" for a product-level save,
     the bare variant id once a size is chosen. A product can therefore hold more than one row;
     we collapse to one piece per product and keep every key so a removal takes them all. */
  function normItem(x) {
    if (x == null) return null;
    if (typeof x === 'string' || typeof x === 'number') { var s = String(x); return /^\d+$/.test(s) ? { id: s, keys: ['p:' + s] } : null; }
    if (typeof x !== 'object') return null;
    var id = x.product_id != null ? x.product_id : (x.productId != null ? x.productId : (x.product && (x.product.id || x.product.product_id)));
    if (id == null || id === '') id = x.id;
    if (id == null || id === '') return null;
    id = String(id).replace(/^gid:\/\/shopify\/Product\//, '');
    if (!/^\d+$/.test(id)) return null;
    var vk = x.variant_key != null ? String(x.variant_key) : null;
    return {
      id: id,
      row_id: (x.product_id != null && x.id != null) ? x.id : null,
      variant_id: x.variant_id != null && x.variant_id !== '' ? String(x.variant_id) : null,
      variant_key: vk,
      keys: vk ? [vk] : ['p:' + id],
      handle: x.handle && !/^\d+$/.test(String(x.handle)) ? String(x.handle) : '',
      title: x.title || '',
      price_at_save: x.price_at_save != null ? x.price_at_save : null,
      note: typeof x.note === 'string' ? x.note : '',
      target_date: x.target_date || x.targetDate || '',
      budget: (x.target_price != null && x.target_price !== '') ? x.target_price : ((x.budget != null && x.budget !== '') ? x.budget : ''),
      added_at: x.added_at || x.created_at || '',
      status: x.status || null
    };
  }
  function normList(d) {
    var raw = Array.isArray(d) ? d : (d && (d.items || d.wishlist || d.results || d.products || d.ids)) || [];
    if (!Array.isArray(raw)) raw = [];
    var out = [], byId = {};
    raw.forEach(function (x) {
      var n = normItem(x); if (!n) return;
      var prev = byId[n.id];
      if (!prev) { byId[n.id] = n; out.push(n); return; }
      n.keys.forEach(function (k) { if (prev.keys.indexOf(k) === -1) prev.keys.push(k); });
      /* the row that carries a chosen size wins; it is the one the server can price and stock-check */
      if (n.variant_id && !prev.variant_id) {
        var keys = prev.keys; for (var k in n) if (Object.prototype.hasOwnProperty.call(n, k)) prev[k] = n[k];
        prev.keys = keys;
      } else {
        if (!prev.note && n.note) prev.note = n.note;
        if (!prev.target_date && n.target_date) prev.target_date = n.target_date;
        if (prev.budget === '' && n.budget !== '') prev.budget = n.budget;
        if (!prev.title && n.title) prev.title = n.title;
        if (!prev.handle && n.handle) prev.handle = n.handle;
      }
    });
    return out;
  }
  Q.normList = normList;
  function keysFor(id) {
    id = String(id);
    var k = (Q.state.keys && Q.state.keys[id]) || [];
    if (k.indexOf('p:' + id) === -1) k = k.concat(['p:' + id]);
    return k;
  }
  Q.keysFor = keysFor;

  /* ---------- meta cache (note / target date / budget), local first ---------- */
  Q.meta = function (id) { var m = Q.state.meta[String(id)]; return m && typeof m === 'object' ? m : {}; };
  Q.setMetaLocal = function (id, patch) {
    id = String(id); var m = Q.meta(id), k;
    for (k in patch) if (Object.prototype.hasOwnProperty.call(patch, k)) m[k] = patch[k];
    m.dirty = true; m.at = Date.now();
    Q.state.meta[id] = m; Q.persist(); return m;
  };
  Q.saveMeta = function (id, patch) {
    var m = Q.setMetaLocal(id, patch);
    if (Q.online === false) return Promise.resolve({ ok: false, offline: true });
    var body = custBody({
      note: m.note || '', target_date: m.target_date || '',
      target_price: (m.budget === '' || m.budget == null) ? null : m.budget
    });
    /* the API addresses a row by id or variant_key, never by product id */
    if (m.row_id) body.id = m.row_id;
    body.variant_key = m.vkey || (m.variant_id ? String(m.variant_id) : 'p:' + String(id));
    body.product_id = String(id);
    return req(EP.note, { method: 'POST', body: body })
      .then(function (r) {
        if (r.ok) { var mm = Q.meta(id); delete mm.dirty; Q.state.meta[String(id)] = mm; Q.persist(); }
        return r;
      });
  };

  /* The shopper picked a size on the wishlist page: move the save onto that variant so the
     server can watch its real stock and price, and drop the product-level row behind it. */
  Q.setVariant = function (id, variantId, extra) {
    id = String(id);
    Q.setMetaLocal(id, { variant_id: variantId ? String(variantId) : null, vkey: variantId ? String(variantId) : 'p:' + id, size_gone_at: 0 });
    if (Q.online === false || !variantId) return Promise.resolve({ ok: false, offline: true });
    var body = custBody({ product_id: id, variant_id: String(variantId), source: 'wishlist-page' });
    if (extra) { if (extra.handle) body.handle = extra.handle; if (extra.title) body.title = extra.title; if (extra.price != null) { body.price_at_save = extra.price; body.currency = extra.currency || 'EUR'; } }
    return req(EP.add, { method: 'POST', body: body }).then(function (r) {
      if (!r.ok) return r;
      var ks = (Q.state.keys && Q.state.keys[id]) || [];
      var stale = ks.filter(function (k) { return String(k) !== String(variantId); });
      if (stale.length) return req(EP.remove, { method: 'POST', body: custBody({ variant_keys: stale }) }).then(function () { return r; });
      return r;
    });
  };

  /* Put a real title and price on a row the heart could only save as a bare id, so Lucy,
     email and the radar see a piece rather than a number. Idempotent: /add upserts. */
  Q.enrich = function (id, d) {
    id = String(id);
    var m = Q.meta(id);
    if (Q.online === false || !d || !d.title || m.enriched) return Promise.resolve({ ok: false });
    var body = custBody({ product_id: id, handle: d.handle || '', title: d.title, source: 'wishlist-page' });
    if (m.variant_id) body.variant_id = String(m.variant_id);
    if (d.price != null) { body.price_at_save = d.price; body.currency = d.currency || 'EUR'; }
    return req(EP.add, { method: 'POST', body: body }).then(function (r) {
      if (r.ok) { Q.setMetaLocal(id, { enriched: true }); var mm = Q.meta(id); delete mm.dirty; Q.state.meta[id] = mm; Q.persist(); }
      return r;
    });
  };

  /* ---------- push pending ops; a pending op only dies on a confirmed answer ---------- */
  var flushing = false;
  Q.flush = function () {
    if (flushing || Q.online === false) return Promise.resolve(false);
    var pend = (Q.state.pending || []).slice();
    if (!pend.length) return Promise.resolve(true);
    flushing = true;
    var i = 0, allOk = true;
    function done(p, ok) {
      if (!ok) { allOk = false; return; }
      Q.state.pending = Q.state.pending.filter(function (x) { return !(x && String(x.id) === String(p.id) && x.op === p.op && x.at === p.at); });
      var sy = Q.state.synced.filter(function (x) { return String(x) !== String(p.id); });
      if (p.op === 'add') sy.push(String(p.id));
      else if (Q.state.keys) delete Q.state.keys[String(p.id)];
      Q.state.synced = sy; Q.persist();
    }
    function next() {
      if (i >= pend.length) { flushing = false; return allOk; }
      var p = pend[i++];
      if (!p || !p.id) { return next(); }
      var url, body;
      if (p.op === 'remove') {
        /* take every row the product ever produced — the product-level one and any sized one */
        url = EP.remove; body = custBody({ variant_keys: keysFor(p.id), product_id: String(p.id) });
      } else {
        url = EP.add; body = custBody({ product_id: String(p.id), source: p.src || 'theme' });
        var mm = Q.meta(p.id);
        if (p.variant_id || mm.variant_id) body.variant_id = String(p.variant_id || mm.variant_id);
      }
      return req(url, { method: 'POST', body: body }).then(function (r) {
        /* 2xx = done. 404/409 on a remove = already gone, also done. Anything else stays queued. */
        var ok = r.ok || (p.op === 'remove' && (r.status === 404 || r.status === 409 || r.status === 410));
        if (r.status === 0 || r.status >= 500 || (r.status === 404 && p.op === 'add')) { Q.online = false; allOk = false; flushing = false; return false; }
        done(p, ok);
        return next();
      });
    }
    return Promise.resolve(next()).then(function (v) {
      flushing = false;
      /* a heart clicked while this flush was in the air is not in the snapshot: take it now,
         rather than making the shopper wait for the next page load */
      if (allOk && Q.online !== false && (Q.state.pending || []).length && passes < 5) { passes++; return Q.flush(); }
      passes = 0;
      return v;
    });
  };
  var passes = 0;

  /* ---------- reconcile: union, then trim only what the server has genuinely dropped ---------- */
  function reconcile(serverItems) {
    var server = {}, order = [];
    serverItems.forEach(function (it) { server[it.id] = it; order.push(it.id); });

    var pendAdd = {}, pendRem = {};
    (Q.state.pending || []).forEach(function (p) { if (!p || !p.id) return; if (p.op === 'add') pendAdd[String(p.id)] = 1; else pendRem[String(p.id)] = 1; });

    var local = Q.local(), out = [], seen = {};
    function push(id) { id = String(id); if (!id || seen[id] || pendRem[id]) return; seen[id] = 1; out.push(id); }

    /* local first so the shopper's own order and their newest saves stay on top */
    local.forEach(function (id) {
      if (server[id] || pendAdd[id]) { push(id); return; }
      /* not on the server, not queued: it was confirmed once and has since been removed
         elsewhere -> honour that. Never seen by the server at all -> keep it and queue it. */
      if (Q.state.synced.indexOf(id) === -1) { Q.queue('add', id, { src: 'rescue' }); push(id); }
    });
    order.forEach(push);

    /* remember every row key per product so a removal can take them all */
    Q.state.keys = Q.state.keys || {};
    serverItems.forEach(function (it) { Q.state.keys[it.id] = it.keys.slice(); });

    /* meta the server knows about wins, unless we still hold an unsent local edit */
    serverItems.forEach(function (it) {
      var mine = Q.meta(it.id);
      if (mine.dirty) {
        mine.row_id = it.row_id || mine.row_id; mine.vkey = it.variant_key || mine.vkey;
        Q.state.meta[it.id] = mine; return;
      }
      Q.state.meta[it.id] = {
        note: it.note || '', target_date: it.target_date || '',
        budget: it.budget === 0 ? 0 : (it.budget || ''),
        variant_id: it.variant_id || mine.variant_id || null,
        vkey: it.variant_key || mine.vkey || null,
        row_id: it.row_id || mine.row_id || null,
        enriched: !!it.title || mine.enriched || false,
        title: it.title || mine.title || '',
        size_gone_at: mine.size_gone_at || 0,
        added_at: it.added_at || ''
      };
    });

    /* synced = exactly what the server just confirmed it holds, minus what we are about to remove */
    Q.state.synced = uniq(order.filter(function (id) { return !pendRem[id]; }));
    Q.state.serverAt = Date.now();
    Q.persist();
    Q.setLocal(out);
    return out;
  }

  /* ---------- pull ---------- */
  Q.pull = function () {
    return req(EP.mine + '?limit=500&' + custQ()).then(function (r) {
      if (!r.ok) {
        Q.online = false;
        Q.lastStatus = r.status;
        Q.refreshUI();
        return { ok: false, status: r.status };
      }
      Q.online = true; Q.lastStatus = 200;
      var items = normList(r.data);
      Q.serverItems = items;
      reconcile(items);
      return { ok: true, items: items };
    });
  };

  /* ---------- claim anonymous saves into the account on sign-in ---------- */
  Q.claim = function (force) {
    if (!CUSTOMER) return Promise.resolve({ ok: false, reason: 'anonymous' });
    if (!force && Q.state.claimed_for === String(CUSTOMER.id)) return Promise.resolve({ ok: true, skipped: true });
    var ids = sessionIds(), i = 0, claimed = 0, any = false;
    function next() {
      if (i >= ids.length) {
        if (any) { Q.state.claimed_for = String(CUSTOMER.id); Q.persist(); }
        return { ok: any, claimed: claimed };
      }
      var s = ids[i++];
      return req(EP.claim, { method: 'POST', body: custBody({ session_id: s }) }).then(function (r) {
        if (r.ok) { any = true; claimed += parseInt(r.data && (r.data.claimed != null ? r.data.claimed : r.data.count), 10) || 0; }
        return next();
      });
    }
    return Promise.resolve(next());
  };

  Q.sourcing = function (payload) {
    var body = custBody(payload || {});
    return req(EP.sourcing, { method: 'POST', body: body, timeout: 20000 });
  };
  Q.sourcingMine = function () { return req(EP.sourcingMine + '?' + custQ()); };

  /* ---------- boot ---------- */
  var booted = false, retries = 0;
  function boot() {
    if (booted) return; booted = true;
    Q.refreshUI();
    Q.ready = Q.pull().then(function (r) {
      if (!r.ok) return r;
      return Q.claim().then(function (c) {
        return Q.flush().then(function () {
          /* a claim moves rows onto the account: read once more so the page shows the truth */
          if (c && c.ok && !c.skipped) return Q.pull();
          return r;
        });
      });
    }).then(function (r) {
      Q.refreshUI(); Q._emit();
      return r;
    }).catch(function () { Q.online = false; Q.refreshUI(); return { ok: false, status: 0 }; });

    /* one quiet retry: a cold API or a flaky first request should not cost the visit */
    setTimeout(function () {
      if (Q.online === false && retries < 1 && (Q.state.pending || []).length) {
        retries++; Q.online = null;
        Q.pull().then(function (r) { if (r.ok) Q.flush(); });
      }
    }, 25000);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
